import { useEffect, useState } from 'react';

interface CountdownTime {
  minutes: number;
  seconds: number;
}

export const useCountdownTimer = (
  endTime: Date,
  onComplete?: () => void
): CountdownTime => {
  const [timeRemaining, setTimeRemaining] = useState<CountdownTime>({
    minutes: 0,
    seconds: 0
  });

  useEffect(() => {
    const updateCountdown = () => {
      const now = new Date().getTime();
      const end = new Date(endTime).getTime();
      const difference = end - now;

      if (difference <= 0) {
        setTimeRemaining({ minutes: 0, seconds: 0 });
        if (onComplete) {
          onComplete();
        }
        return;
      }

      const minutes = Math.floor((difference % (1000 * 60 * 60)) / (1000 * 60));
      const seconds = Math.floor((difference % (1000 * 60)) / 1000);

      setTimeRemaining({ minutes, seconds });
    };

    updateCountdown();
    const interval = setInterval(updateCountdown, 1000);

    return () => clearInterval(interval);
  }, [endTime, onComplete]);

  return timeRemaining;
};

